
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const ProductsCTA = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section ref={ref} className="py-16 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gradient-to-br from-navy via-navy to-navy/95 rounded-3xl lg:rounded-[2.5rem] overflow-hidden">
          {/* Background Decorations */}
          <div className="absolute inset-0 opacity-10">
            <motion.div
              animate={{ x: [0, 30, 0], y: [0, -20, 0] }}
              transition={{ duration: 15, repeat: Infinity, ease: 'easeInOut' }}
              className="absolute top-0 right-0 w-96 h-96 bg-green rounded-full blur-3xl"
            />
            <motion.div
              animate={{ x: [0, -20, 0], y: [0, 25, 0] }}
              transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
              className="absolute bottom-0 left-0 w-80 h-80 bg-teal rounded-full blur-3xl"
            />
          </div>

          {/* Animated Lines */}
          <div className="absolute inset-0 overflow-hidden opacity-[0.04]">
            <motion.div
              animate={{ x: ['-100%', '100%'] }}
              transition={{ duration: 8, repeat: Infinity, ease: 'linear' }}
              className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-white to-transparent"
            />
            <motion.div
              animate={{ x: ['100%', '-100%'] }}
              transition={{ duration: 10, repeat: Infinity, ease: 'linear' }}
              className="absolute top-3/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-white to-transparent"
            />
          </div>

          <div className="relative px-8 sm:px-12 lg:px-20 py-16 sm:py-20 lg:py-24 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7 }}
            >
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={inView ? { scale: 1, opacity: 1 } : {}}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-green/20 rounded-2xl mx-auto mb-8"
              >
                <i className="ri-customer-service-2-line text-green text-3xl sm:text-4xl" />
              </motion.div>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight">
                İhtiyacınıza Özel<br className="hidden sm:block" />
                Çözüm Arıyor musunuz?
              </h2>
              <p className="text-base sm:text-lg text-white/80 mb-10 sm:mb-12 max-w-2xl mx-auto leading-relaxed">
                Uzman ekibimiz, özel tasarım ve üretim talepleriniz için yanınızda.
                Hemen iletişime geçin, size en uygun çözümü birlikte bulalım.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
                <Link
                  to="/quote"
                  className="group w-full sm:w-auto px-10 sm:px-12 py-4 bg-gradient-to-r from-green to-teal text-white text-sm sm:text-base font-semibold rounded-lg hover:shadow-2xl hover:shadow-green/30 hover:-translate-y-1 transition-all duration-500 whitespace-nowrap cursor-pointer text-center"
                >
                  <span className="flex items-center justify-center gap-2">
                    Teklif Alın
                    <motion.i
                      animate={{ x: [0, 4, 0] }}
                      transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
                      className="ri-arrow-right-line text-lg"
                    />
                  </span>
                </Link>
                <Link
                  to="/contact"
                  className="w-full sm:w-auto px-10 sm:px-12 py-4 bg-white/10 border border-white/25 text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-white hover:text-navy hover:-translate-y-1 transition-all duration-500 whitespace-nowrap cursor-pointer text-center backdrop-blur-sm"
                >
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-phone-line" />
                    İletişime Geçin
                  </span>
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsCTA;
